import { useMemo } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Button,
} from "@mui/material";
import type { TimelineData, TimeRange } from "../models";
import { dateTimeText, numberText, summarize } from "../timeline";

export function TimelineSummary({
	data,
	range,
	open,
}: {
	data: TimelineData;
	range: TimeRange;
	open: (time: number) => void;
}) {
	const buckets = useMemo(() => summarize(data, range), [data, range]);
	return (
		<div className="timeline-summary">
			<Table size="small" stickyHeader aria-label="Operations summary">
				<TableHead>
					<TableRow>
						<TableCell>Local period</TableCell>
						<TableCell align="right">Billets discharged</TableCell>
						<TableCell align="right">Cobble flags</TableCell>
						<TableCell align="right">Stop minutes</TableCell>
						<TableCell align="right">Roll changes</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{buckets.map((b) => (
						<TableRow key={b.start} hover>
							<TableCell>
								<Button size="small" onClick={() => open(b.start)}>
									{dateTimeText(b.start)} –{" "}
									{new Date(b.end).toLocaleTimeString([], {
										hour: "2-digit",
										minute: "2-digit",
									})}
								</Button>
							</TableCell>
							<TableCell align="right">{b.billets}</TableCell>
							<TableCell align="right">{b.cobbles}</TableCell>
							<TableCell align="right">{numberText(b.stopMinutes)}</TableCell>
							<TableCell align="right">{b.rolls}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
}
